import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import { user } from 'src/StateObserver';
import { isTeamFeatureUnlocked } from 'src/replicant/team/team.getters';
import { getTeamsTutorialFSM } from '../fsm/45-TeamsTutorial';
import { setupTutorialFSM } from '../tutorial.util';

export class TeamsTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'teams';
  private machine = setupTutorialFSM(
    ['match2LevelCompleted', 'match2LevelFailed', 'gameStarted'],
    () => getTeamsTutorialFSM(this.services),
  );

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    // Feature should be unlocked.
    if (!isTeamFeatureUnlocked(user())) return false;
    // Should not be in a team. This might never happen, but covering it anyway.
    if (user().team.currentTeamId) return false;

    // Handle event.
    return this.machine.handleEvent(event);
  }
}
